import clsx from 'clsx'

export function Logo({ variant = 'dark', className }) {
  const logo = GM_STATE?.assets?.logo?.[variant]
  if (!logo) return null
  return (
    <div className={clsx('flex justify-center', className)}>
      <a href="/" title={GM_STATE.shopify.shopName} className="text-center text-xl font-bold tracking-widest">
        <img className="relative -bottom-1 h-6 md:h-8" src={logo} />
      </a>
    </div>
  )
}
